// extracted by mini-css-extract-plugin
export default {"reactCalendar":"Calendar_reactCalendar__aXAcY","react-calendar__navigation":"Calendar_react-calendar__navigation__jf8Ma"};